export const SIDENAV_COLLAPSED_KEY = "signpost-sidenav-collapsed";

export const SIDENAV_COLLAPSED_ATTR = "data-sidenav-collapsed";

/**
 * Stamps the saved rail width on <html> before first paint, the same way the
 * theme and nav-gate bootstraps do. Restoring it from an effect instead would
 * paint a 240px rail and snap it to 72px a frame later, shoving the page
 * sideways on every load for anyone who collapsed it.
 */
export const SIDENAV_COLLAPSE_BOOTSTRAP = `
(function() {
  try {
    if (localStorage.getItem('${SIDENAV_COLLAPSED_KEY}') === '1') {
      document.documentElement.setAttribute('${SIDENAV_COLLAPSED_ATTR}', '1');
    }
  } catch (e) {}
})();
`;

export function readSideNavCollapsed(): boolean {
    if (typeof window === "undefined") return false;
    try {
        return window.localStorage.getItem(SIDENAV_COLLAPSED_KEY) === "1";
    } catch {
        return false;
    }
}

export function applySideNavCollapsed(collapsed: boolean): void {
    if (typeof window === "undefined") return;
    try {
        window.localStorage.setItem(
            SIDENAV_COLLAPSED_KEY,
            collapsed ? "1" : "0",
        );
    } catch {}
    const el = document.documentElement;
    if (collapsed) el.setAttribute(SIDENAV_COLLAPSED_ATTR, "1");
    else el.removeAttribute(SIDENAV_COLLAPSED_ATTR);
}
